import {
  Stack,
  TextField,
  TextFieldProps,
  Tooltip,
  Typography,
} from '@mui/material'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { observer } from 'mobx-react'
import moment, { Moment } from 'moment'
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { checkEditCreationDate } from '../../../../../helpers/ordersUtiles'
import { RequestType } from '../../../types/Request.type'
import { titleSx } from '../styles/styles'

type InstallationDatePickerProps = {
  installationDate: string | Moment | null
  setInstallationDate: React.Dispatch<
    React.SetStateAction<string | Moment | null>
  >
  request: RequestType
  dateError: string | boolean
}

const InstallationDatePicker: FC<InstallationDatePickerProps> = ({
  installationDate,
  setInstallationDate,
  request,
  dateError,
}) => {
  const intl = useIntl()

  const editWithoutError =
    request.status === 6 && [0, 3].includes(request.dataCheckingStatus)

  // если есть  отчетный период проверяем совпадает ли новая дата с периодом
  const installationDateError =
    getReportPeriodError(request, installationDate) && !editWithoutError

  return (
    <Stack spacing={'10px'}>
      <Typography variant='body2' sx={titleSx}>
        Дата установки
      </Typography>
      {installationDateError && (
        <Tooltip
          title={intl.formatMessage({
            id: 'Дату установки можно отредактировать только в рамках отчётного периода текущего отчёта',
          })}
        >
          <img src={getImageSrc('tooltip')} alt={''} style={imgStyle} />
        </Tooltip>
      )}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DesktopDatePicker
          leftArrowButtonText={'Предыдущий месяц'}
          rightArrowButtonText={'Следующий месяц'}
          maxDate={moment()}
          renderInput={({ inputProps, ...props }) => {
            return (
              <TextField
                placeholder={'ДД.MM.ГГГГ'}
                fullWidth={true}
                {...(props as TextFieldProps)}
                {...(inputProps as TextFieldProps)}
                error={installationDateError || !!dateError}
                helperText={dateError}
              />
            )
          }}
          value={installationDate ?? ''}
          onChange={(newValue) => {
            const newDate = newValue ? moment(newValue) : null
            setInstallationDate(newDate)
          }}
          inputFormat={'DD.MM.YYYY'}
          components={{
            OpenPickerIcon: () => (
              <img alt={'calendar icon'} src={getImageSrc('calendar')} />
            ),
          }}
        />
      </LocalizationProvider>
    </Stack>
  )
}

const imgStyle = { width: '18px', marginTop: 0, marginBottom: '-4px' }

export const getReportPeriodError = (
  request: RequestType,
  installationDate: string | moment.Moment | null,
) => {
  const {
    installationDate: initDate,
    reportPeriodFrom,
    reportPeriodTo,
    reportId,
  } = request

  return (
    !!reportPeriodFrom &&
    !!reportPeriodTo &&
    !!reportId &&
    !checkEditCreationDate(
      initDate,
      installationDate,
      reportPeriodFrom,
      reportPeriodTo,
    )
  )
}

export default observer(InstallationDatePicker)
